import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Card, CardBody, Col, Row, Input, Label, Button, CardHeader } from 'reactstrap';
import SEO from '../../components/common/SEO';

const ChangePassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPasswords, setShowPasswords] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            toast.error("New passwords do not match!");
            return;
        }

        if (newPassword.length < 6) {
            toast.error("New password must be at least 6 characters long.");
            return;
        }

        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (!userInfo || !userInfo.id) {
            toast.error("User information not found. Please log in again.");
            return;
        }

        setLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
            const response = await axios.post(`${apiBaseUrl}/vendors/${userInfo.id}/change-password`, {
                newPassword
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success(response.data.message || "Password changed successfully!");
            setNewPassword('');
            setConfirmPassword('');
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to change password.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <React.Fragment>
            <SEO title="Change Password | Mangoloops" />
            {/* <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">Security Settings</h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><a href="javascript: void(0);" className="text-success">Settings</a></li>
                                <li className="breadcrumb-item active">Change Password</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div> */}

            <Row className="justify-content-center mt-2">
                <Col xxl={5} lg={7}>
                    <Card className="border-0 shadow-sm">
                        <CardHeader className="bg-light-subtle border-bottom-0 py-3">
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 me-3">
                                    <div className="avatar-sm">
                                        <div className="avatar-title bg-soft-success text-success rounded-circle fs-18">
                                            <i className="ri-lock-password-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="card-title mb-0">Change Password</h5>
                                    <p className="text-muted mb-0 small">Update your account credentials</p>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody className="p-4">
                            <form onSubmit={handleSubmit}>

                                <div className="mb-4">
                                    <Label className="form-label text-muted fw-bold">New Password</Label>
                                    <Input
                                        type={showPasswords ? "text" : "password"}
                                        className="form-control form-control-lg bg-light border-light"
                                        placeholder="Enter new password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        required
                                        style={{ fontSize: '15px' }}
                                    />
                                    <div className="form-text text-muted">Password must be at least 6 characters long.</div>
                                </div>

                                <div className="mb-4">
                                    <Label className="form-label text-muted fw-bold">Confirm New Password</Label>
                                    <Input
                                        type={showPasswords ? "text" : "password"}
                                        className="form-control form-control-lg bg-light border-light"
                                        placeholder="Confirm new password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                        style={{ fontSize: '15px' }}
                                    />
                                </div>

                                <div className="d-flex align-items-center justify-content-between mt-4">
                                    <div className="form-check">
                                        <input 
                                            className="form-check-input" 
                                            type="checkbox" 
                                            id="showPassCheck" 
                                            checked={showPasswords}
                                            onChange={() => setShowPasswords(!showPasswords)}
                                        />
                                        <label className="form-check-label text-muted" htmlFor="showPassCheck">
                                            Show all passwords
                                        </label>
                                    </div>
                                    <Button 
                                        color="success" 
                                        type="submit" 
                                        className="btn-lg px-4 shadow-sm" 
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Updating...
                                            </>
                                        ) : (
                                            <span>
                                                Update Password <i className="ri-arrow-right-line ms-1 align-middle"></i>
                                            </span>
                                        )}
                                    </Button>
                                </div>
                            </form>
                        </CardBody>
                    </Card>
                    
                    <div className="mt-4 text-center">
                        <p className="text-muted mb-0">
                            Logged in as <span className="fw-bold text-success">{JSON.parse(localStorage.getItem('userInfo'))?.email}</span>
                        </p>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default ChangePassword;


